import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Text from "../../img/sammi.png";
import LoginService from '../../services/login.service';
import { useTranslation } from 'react-i18next';
import { UserType } from '../../types/Staff';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';

export const ResetPasswordPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const canSave = password === confirmPassword;
    const queryParams = new URLSearchParams(location.search);
    const [userType, setUserType] = useState('');
    const [isEyeEnabled, setIsEyeEnabled] = useState(true);
    const token = queryParams.get('token');
    const { t } = useTranslation();

    const handleSubmit = (
      e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    ) => {
      e.preventDefault();
      resetPassword();
    };

    const toggleEye = () => {
      const newState = !isEyeEnabled;
      setIsEyeEnabled(newState);
    };

    const resetPassword = async () => {
        if (token) {
            const response = await LoginService.resetPassword(token, password);

            if (response.ok) {
                if (userType === UserType.STAFF) {
                    navigate('/applinks');
                } else {
                    navigate('/login');
                }
            }
        }
    };

    useEffect(() => {
        if (token) {
            const payload = JSON.parse(atob(token.split('.')[1]));
            setUserType(payload.userType);
        } else {
            navigate('/login');
        }
    }, []);

    return (
<div className="flex flex-col items-center justify-center h-screen bg-slate-100">
  <div className="flex flex-col items-center justify-center bg-white rounded-lg shadow-lg p-5 md:p-10 w-full md:w-1/4">
    <div className="flex flex-shrink-0 items-center mb-5">
      <img className="block h-15 w-auto" src={Text} alt="Your Company" />
    </div>
    <h1 className="text-2xl font-bold mb-5">
      {location.pathname == '/reset-password'
        ? t('resetpassword.resetPassword')
        : t('resetpassword.setPassword')}
    </h1>
    <form className="flex flex-col items-center justify-center w-full">
      <div className="relative w-full mb-3">
        <label className="sr-only" htmlFor="password">
          {t('resetpassword.password')}
        </label>
        <input
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          type={isEyeEnabled ? 'password' : 'text'}
          placeholder={t('resetpassword.password')}
           className="border border-gray-400 p-3 rounded-lg w-full pr-10"
          autoComplete="current-password"
          required
        />
        <button
          type="button"
          className="absolute right-3 top-1/2 transform -translate-y-1/2"
          onClick={toggleEye}
        >
          {isEyeEnabled ? (
            <EyeSlashIcon className="h-6 w-6" aria-hidden="true" />
          ) : (
            <EyeIcon className="h-6 w-6" aria-hidden="true" />
          )}
        </button>
      </div>

      <div className="relative w-full mb-3">
        <label className="sr-only" htmlFor="confirmPassword">
          {t('resetpassword.confirmPassword')}
        </label>
        <input
          id="confirmPassword"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          type={isEyeEnabled ? 'password' : 'text'}
          placeholder={t('resetpassword.confirmPassword')}
           className="border border-gray-400 p-3 rounded-lg w-full pr-10"
          autoComplete="current-password"
          required
        />

        <button
          type="button"
          className="absolute right-3 top-1/2 transform -translate-y-1/2"
          onClick={toggleEye}
        >
          {isEyeEnabled ? (
            <EyeSlashIcon className="h-6 w-6" aria-hidden="true" />
          ) : (
            <EyeIcon className="h-6 w-6" aria-hidden="true" />
          )}
        </button>
      </div>

      <button
        onClick={handleSubmit}
        className={`text-white ${
          canSave ? 'bg-purple-600' : 'bg-purple-200'
        } p-3 rounded-lg w-full`}
        type="submit"
        disabled={!canSave}
      >
        {location.pathname === '/reset-password'
          ? t('resetpassword.resetPassword')
          : t('resetpassword.setPassword')}
      </button>
    </form>
  </div>
</div>

    );
}
